import { type ReactNode, useEffect, useState } from 'react';
import { type Location, useLocation, useNavigationType } from 'react-router';

import { LocationContext } from './LocationContext';

export const LocationProvider = ({ children }: { children: ReactNode | ReactNode[] }) => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const [previous, setPrevious] = useState<Location | undefined>();
  const [current, setCurrent] = useState(location);

  // biome-ignore lint/correctness/useExhaustiveDependencies: `current` is intentionally excluded from deps — it must be read as a closure value to capture the old location before the update
  useEffect(() => {
    if (navigationType !== 'POP') {
      setPrevious(current);
      setCurrent(location);
    }
  }, [location, navigationType]);

  return (
    <LocationContext.Provider
      value={{
        previous,
        current,
        historyAction: navigationType,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};
